export const FLOW_STATUS = Object.freeze({
  /**
   * Set on flow failure and the flow
   * is automatically shut off by our systems.
   */
  disabled: 'disabled' as const,
  /**
   * Set as the initial flow status.
   * Once a flow is published, it
   * can no longer be in `draft` mode.
   */
  draft: 'draft' as const,
  /**
   * Set when a published flow
   * should not be executable on a live site.
   */
  off: 'off' as const,
  /**
   * Set when a published flow
   * should be executable on a live site.
   */
  on: 'on' as const,
});

export const PUBLISHED_FLOW_STATUS = Object.freeze({
  disabled: FLOW_STATUS.disabled,
  off: FLOW_STATUS.off,
  on: FLOW_STATUS.on,
});

export type FlowStatus = keyof typeof FLOW_STATUS;
export type PublishedFlowStatus = keyof typeof PUBLISHED_FLOW_STATUS;

export const FLOW_STATE_TYPES = {
  misconfigured: 'misconfigured' as const,
  'form-connected': 'form-connected' as const,
} as const;

export type FlowStateType = keyof typeof FLOW_STATE_TYPES;
